import Velocity from 'velocity-animate'

function toggleAccordian(accordian) {
  const body = accordian.querySelectorAll('.accordian-item__body')[0]
  if (accordian.classList.contains('is-open')) {
    accordian.classList.remove('is-open')
    Velocity(body, 'slideUp', { duration: 200 })
  } else {
    accordian.classList.add('is-open')
    Velocity(body, 'slideDown', { duration: 200 })
  }
}

function addAccordianClickListener(accordian) {
  const toggle = accordian.querySelectorAll('.accordian-item__toggle')[0]
  toggle.addEventListener('click', function () {
    toggleAccordian(accordian)
  }, true)
}

(function(){

const accordians = document.querySelectorAll('.accordian-item');

for (let i = 0; i < accordians.length; i++) {
  let accordian = accordians[i]
  addAccordianClickListener(accordian)
}

})();


// WEBPACK FOOTER //
// ./assets/js/accordian/accordian.js